import bancorLogo from "../../assets/tokens/bnt.png";
import ethLogo from "../../assets/tokens/eth.png";
import batLogo from "../../assets/tokens/bat.png";
import enjLogo from "../../assets/tokens/enj.png";
import kncLogo from "../../assets/tokens/knc.png";
import omgLogo from "../../assets/tokens/omg.png";
import daiLogo from "../../assets/tokens/dai.png";
import manaLogo from "../../assets/tokens/mana.png";
import powrLogo from "../../assets/tokens/powr.png";
import mkrLogo from "../../assets/tokens/mkr.png";
import antLogo from "../../assets/tokens/ant.png";
import gnoLogo from "../../assets/tokens/gno.png";
import dgdLogo from "../../assets/tokens/dgd.png";
import sntLogo from "../../assets/tokens/snt.png";
import rdnLogo from "../../assets/tokens/rdn.png";
import sanLogo from "../../assets/tokens/san.png";
import usdLogo from "../../assets/tokens/usd.png";
import drgnLogo from "../../assets/tokens/drgn.png";
import busdLogo from "../../assets/tokens/busd.png";
import edgLogo from "../../assets/tokens/edg.png";
import elfLogo from "../../assets/tokens/elf.png";
import gtoLogo from "../../assets/tokens/gto.png";
import reqLogo from "../../assets/tokens/req.png";
import rlcLogo from "../../assets/tokens/rlc.png";
import srnLogo from "../../assets/tokens/srn.png";
import stormLogo from "../../assets/tokens/storm.png";
import taasLogo from "../../assets/tokens/taas.png";
import usdcLogo from "../../assets/tokens/usdc.png";
import tknLogo from "../../assets/tokens/tkn.png";
import aionLogo from "../../assets/tokens/aion.png";
import npxsLogo from "../../assets/tokens/npxs.png";
import plrLogo from "../../assets/tokens/plr.png";
import rcnLogo from "../../assets/tokens/rcn.png"
import kinLogo from "../../assets/tokens/kin.png";
import vibLogo from "../../assets/tokens/vib.png";
import dataLogo from "../../assets/tokens/data.png";
import waxLogo from "../../assets/tokens/wax.png";
import mtlLogo from "../../assets/tokens/mtl.png";
import mftLogo from "../../assets/tokens/mft.png";
import btcLogo from "../../assets/tokens/btc.png";
import usdtLogo from "../../assets/tokens/usdt.png";
import zrxLogo from "../../assets/tokens/zrx.png";
import repLogo from "../../assets/tokens/rep.png";
import tusdLogo from "../../assets/tokens/tusd.png";
import chainlinkLogo from "../../assets/tokens/chainlink.png";
import nexoLogo from "../../assets/tokens/nexo.png";
import renLogo from "../../assets/tokens/ren.png";
import loomLogo from "../../assets/tokens/loom.png";
import snxLogo from "../../assets/tokens/snx.png";
import indLogo from "../../assets/tokens/ind.png";
import aidLogo from "../../assets/tokens/aid.png";
import catLogo from "../../assets/tokens/cat.png";
import veeLogo from "../../assets/tokens/vee.png";
import wingsLogo from "../../assets/tokens/wings.png";
import amnLogo from "../../assets/tokens/amn.png";
import instarLogo from "../../assets/tokens/instar.png";
import mdtLogo from "../../assets/tokens/mdt.png";
import mfgLogo from "../../assets/tokens/mfg.png";
import baxLogo from "../../assets/tokens/bax.png";
import xdceLogo from "../../assets/tokens/xdce.png";
import boxxLogo from "../../assets/tokens/boxx.png";
import ceekLogo from "../../assets/tokens/ceek.png";
import mybLogo from "../../assets/tokens/myb.png";
import rblxLogo from "../../assets/tokens/rblx.png";
import ziptLogo from "../../assets/tokens/zipt.png";
import locLogo from "../../assets/tokens/loc.png";
import fxcLogo from "../../assets/tokens/fxc.png";
import qdaoLogo from "../../assets/tokens/qdao.png";
import c20Logo from "../../assets/tokens/c20.png";
import nmrLogo from "../../assets/tokens/nmr.png";
import metLogo from "../../assets/tokens/met.png";
import mlnLogo from "../../assets/tokens/mln.png";
import keyLogo from "../../assets/tokens/key.png";


export const getIcon = (symbol) => {
    switch (symbol) {
        case 'ETH':
            return ethLogo;
        case 'DAI':
            return daiLogo;
        case 'BNT':
            return bancorLogo;
        case 'BAT':
            return batLogo;
        case 'ENJ':
            return enjLogo;
        case 'KNC':
            return kncLogo;
        case 'OMG':
            return omgLogo;
        case 'MANA':
            return manaLogo;
        case 'POWR':
            return powrLogo;
        case 'MKR':
            return mkrLogo;
        case 'ANT':
            return antLogo;
        case 'GNO':
            return gnoLogo;
        case 'DGD':
            return dgdLogo;
        case 'DGD':
            return dgdLogo;
        case 'SNT':
            return sntLogo;
        case 'RDN':
            return rdnLogo;
        case 'SDN':
            return sdnLogo;
        case 'SAN':
            return sanLogo;
        case 'USDB':
            return bancorLogo;
        case 'BUSD':
            return busdLogo;
        case 'DRGN':
            return drgnLogo;
        case 'EDG':
            return edgLogo;
        case 'ELF':
            return elfLogo;
        case 'GTO':
            return gtoLogo;
        case 'REQ':
            return reqLogo;
        case 'RLC':
            return rlcLogo;
        case 'SRN':
            return srnLogo;
        case 'STORM':
            return stormLogo;
        case 'TAAS':
            return taasLogo;
        case 'USDC':
            return usdcLogo;
        case 'TKN':
            return tknLogo;
        case 'AION':
            return aionLogo;
        case 'NPXS':
            return npxsLogo;
        case 'PLR':
            return plrLogo;
        case 'RCN':
            return rcnLogo;
        case 'KIN':
            return kinLogo;
        case 'VIB':
            return vibLogo;
        case 'DATA':
            return dataLogo;
        case 'WAX':
            return waxLogo;
        case 'MTL':
            return mtlLogo;
        case 'MFT':
            return mftLogo;
        case 'WBTC':
            return btcLogo;
        case 'USDT':
            return usdtLogo;
        case 'ZRX':
            return zrxLogo;
        case 'REP':
            return repLogo;
        case 'TUSD':
            return tusdLogo;
        case 'LINK':
            return chainlinkLogo;
        case 'NEXO':
            return nexoLogo;
        case 'REN':
            return renLogo;
        case 'LOOM':
            return loomLogo;
        case 'SNX':
            return snxLogo;
        case 'IND':
            return indLogo;
        case 'AID':
            return aidLogo;
        case 'CAT':
            return catLogo;
        case 'VEE':
            return veeLogo;
        case 'WINGS':
            return wingsLogo;
        case 'AMN':
            return amnLogo;
        case 'INSTAR':
            return instarLogo;
        case 'MDT':
            return mdtLogo;
        case 'MFG':
            return mfgLogo;
        case 'BAX':
            return baxLogo;
        case 'XDCE':
            return xdceLogo;
        case 'BOXX':
            return boxxLogo;
        case 'CEEK':
            return ceekLogo;
        case 'MYB':
            return mybLogo;
        case 'RBLX':
            return rblxLogo;
        case 'ZIPT':
            return ziptLogo;
        case 'LOC':
            return locLogo;
        case 'FXC':
            return fxcLogo;
        case 'QDAO':
            return qdaoLogo;
        case 'USDQ':
            return qdaoLogo;
        case 'C20':
            return c20Logo;
        case 'NMR':
            return nmrLogo;
        case 'MET':
            return metLogo;
        case 'MLN':
            return mlnLogo;
        case 'KEY':
            return keyLogo;
        default:
            return ethLogo;
    }
}

export const getDefaultTokenAddress = (symbol) => {
    switch (symbol) {
        case 'BNT':
            return "0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C";
        case 'ETH':
            return "0xc0829421C1d260BD3cB3E0F06cfE2D52db2cE315";
        case 'DAI':
            return "0x6B175474E89094C44Da98b954EedeAC495271d0F";
        case 'ENJ':
            return "0xF629cBd94d3791C9250152BD8dfBDF380E2a3B9c";
        case 'BAT':
            return "0x0D8775F648430679A709E98d2b0Cb6250d2887EF";
        case 'KNC':
            return "0xdd974D5C2e2928deA5F71b9825b8b646686BD200";
        case 'MANA':
            return "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942";
        case 'POWR':
            return "0x595832F8FC6BF59c85C527fEC3740A1b7a361269";
        case 'MKR':
            return "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2";
        case 'ANT':
            return "0x960b236A07cf122663c4303350609A66A7B288C0";
        case 'GNO':
            return "0x6810e776880C02933D47DB1b9fc05908e5386b96";
        case 'OMG':
            return "0xd26114cd6EE289AccF82350c8d8487fedB8A0C07";
        case 'SNT':
            return "0x744d70FDBE2Ba4CF95131626614a1763DF805B9E";
        case 'RDN':
            return "0x255Aa6DF07540Cb5d3d297f0D0D4D84cb52bc8e6";
        case 'SAN':
            return "0x7C5A0CE9267ED19B22F8cae653F198e3E8daf098";
        case 'USDB':
            return "0x309627af60F0926daa6041B8279484312f2bf060";
        case 'USDC':
            return "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48";
        default:
            return "";
    }
}


export const getRopstenTokenAddress = (symbol) => {
    switch (symbol) {
        case 'BNT':
            return "0x62bd9D98d4E188e281D7B78e29334969bbE1053c";
        case 'ETH':
            return "0xD368b98d03855835E2923Dc000b3f9c2EBF1b27b";
        case 'XXX':
            return "0x8aD24A87B819343679BB2611C093b0F598f7fb3e";
        case 'YYY':
            return "0x8beB0728c77bd9258aAC36f8b2d94085f48Aa686";
        default:
            return "";
    }
}
